import React from 'react'

import { IconClose } from '../../icons/close'
import { IconButton } from '../../button'
import { Modal, ModalAriaProps } from '../../modal'
import styles from './youtube-embed-popup.module.scss'

interface VideoPopupProps {
  isOpen: boolean
  url: string
  title: string
  hidePopup: () => void
  autoplay?: boolean
  aria?: Partial<ModalAriaProps>
  dropShadow?: boolean
}

export const VideoPopup: React.FC<VideoPopupProps> = ({ hidePopup, url, isOpen, autoplay, title }) => {
  const youtubeParams = `?rel=0&autoplay=${autoplay ? '1' : '0'}&autohide=1&enablejsapi=1&showinfo=0&wmode=opaque`
  const fullYoutubeUrl = `${url}${youtubeParams}`

  return (
    <Modal isOpen={isOpen} label={title} onRequestClose={hidePopup}>
      <div className={styles.content}>
        <div className={styles.closeButtonRowStyle}>
          <IconButton onClick={hidePopup} aria-label="Close video popup">
            <IconClose color="neutral0" />
          </IconButton>
        </div>
        <iframe src={fullYoutubeUrl} allowFullScreen={false} allow={autoplay ? 'autoplay' : undefined} title={title} />
      </div>
    </Modal>
  )
}
